import { apiRequest } from './api';

export const getUsers = () =>
  apiRequest('GET', '/users');

export const getUser = (id: string) =>
  apiRequest('GET', `/users/${id}`);

export const createUser = (data: any) =>
  apiRequest('POST', '/users', data);

export const updateUser = (id: string, data: any) =>
  apiRequest('PUT', `/users/${id}`, data);

export const updateUserProtocol = (id: string, data: any) =>
  apiRequest('PUT', `/users/${id}/protocol`, data);

export const deleteUser = (id: string) =>
  apiRequest('DELETE', `/users/${id}`);


// Console accessible debug methods available in development mode
if(process.env.NODE_ENV === 'development') {
  window.getUsers = getUsers;
  window.getUser = getUser;
  window.createUser = createUser;
  window.updateUser = updateUser;
  window.updateUserProtocol = updateUserProtocol;
  window.deleteUser = deleteUser;
}